module.exports = __webpack_public_path__ + "static/media/BrowserFirefox.192d6b7a.png";